import axios from 'axios';
import _ from 'lodash'
import { Commit, ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import { BoothsState, BoothConditions, Booth } from '@/store/booths/types';
import { getPagerFromApiResponse } from '../utils';

const actions: ActionTree<BoothsState, RootState> = {
  /**
   * ブース一覧取得
   */
  fetchBooths: async (
    { commit, dispatch, getters },
    { conditions, page = 1 }
    : { conditions?: BoothConditions, page: number },
  ) => {
    const { headers, data } = await axios.get('/booths', {
      params: {
        page,
        ..._.pickBy({
          universityCode: conditions?.university?.code,
          campusCodes: conditions?.campuses?.map(({ code }) => code).join(','),
          removedPagingLimit: conditions?.removedPagingLimit ? 1 : 0,
        }),
      },
    })

    await Promise.all([
      'fetchMasterUniversities',
      'fetchMasterCampuses',
    ].map((key) => dispatch(key)))

    const booths = _.map(data, (d): Booth => ({
      id: d.id,
      university: getters.findUniversityByCode(d.universityCode),
      campus: getters.findCampusByCode(d.campusCode),
      building: d.building,
      room: d.room,
      number: d.number,
      size: d.size,
      status: d.status,
    }))

    commit('fetchedBooths', {
      pager: getPagerFromApiResponse(page, headers),
      booths,
    });
  },

  /**
   * Booth一覧をCSVで取得
   */
  downloadBoothsByCsv: () => axios.get('/booths/csv'),

  /**
   * Booth一覧をCSV登録
   * @param csvFile Booth CSV
   */
  importBoothsByCsv: (context, csvFile: File) => {
    const formData = new FormData();
    formData.append('csv', csvFile);
    return axios.post('/booths/sync', formData);
  },
};

export default actions;
